import {
  Grid,
  IconButton,
  makeStyles,
  TextField,
  Tooltip,
} from "@material-ui/core";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import styles from "assets/jss/material-dashboard-pro-react/components/tasksStyle.js";
import { Row } from "react-table";
import ActionModal from "@components/Modal/ActionModal";
import { useMutation } from "@apollo/client";
import clientSimulator from "utils/clientSimulator";
import useNotifier from "hooks/useNotifier";
import {
  DeleteItemBatch,
  DeleteItemBatchVariables,
} from "../types/DeleteItemBatch";
import { deleteItemBatchMutation } from "../mutations";
import {
  useBatchFactoryExportV2Query,
  useBatchFactoryOpenTokenExportV2Query,
} from "../queries";
import { useNavigate } from "react-router-dom";
import { itemBatchRoutes } from "../constants";
import BatchTokenizeModal from "./BatchTokenize/BatchTokenizeModal";
import GridContainer from "@components/Grid/GridContainer";
import GridItem from "@components/Grid/GridItem";
import { Formik } from "formik";
import HoverDropdown from "@components/CustomDropdown/HoverDropdown";
import { ItemBatchContext } from "../context/BatchProvider";
import DrawerSidebar from "@components/Drawer/DrawerSidebar";
import { FleetContext } from "../../fleet/context/FleetProvider";
import { PAGE_LIST_LIMIT } from "@constants";
import OVSForm from "@components/Form/OVSForm";
import Button from "@components/CustomButtons/Button";
import AllItemsPage from "../../item/components/AllItemsPage";
import { productQIDOptions } from "../constants";
import useProvisionBatch from "../hooks/useProvisionBatch";
import { ItemContext } from "../../item/context/ItemProvider";
import useBatchCode from "../hooks/useBatchCode";
import * as _ from "lodash";
import * as Yup from "yup";
import { useLazyGetAllItemsQuery } from "../../item/queries";
import { QueryOrder } from "admin/types/globalTypes";
import TextInput from '@components/CustomInput/TextInput';
import { reassignBatchItemsFromItemFleetMutation, assignItemBatchToItemFleetMutation } from "../mutations";
import { reassignBatchItemsFromItemFleet, reassignBatchItemsFromItemFleetVariables } from '../types/reassignBatchItemsFromItemFleet'
import { assignItemBatchToItemFleet, assignItemBatchToItemFleetVariables } from '../types/assignItemBatchToItemFleet'
import { handleGQLErrors } from "utils/gqlErrors";
import { useGetTotalItemsInBatch } from "../hooks/useGetToalItemsInBatch";
import { numberWithCommas } from "utils";
import BatchProgressPage from "./batchProgressPage";
import { useBatchAvatarCsvExport } from "../avatarCsvExport";
import CustomSelect from '@components/CustomSelect/CustomSelect';
import { OpenTokenBatchCode, OpenTokenBatchCodeVariables } from "../types/OpenTokenBatchCode";
import { openTokenBatchCodeMutation } from "../mutations";
import { OpenTokenBatchCodeInput } from "../../types/thingsGlobalTypes";
import { OpenTokenCodeType } from "../../types/thingsGlobalTypes";
interface IProps {
  row: Row;
}

// @ts-ignore
const useStyles = makeStyles(styles);

const ItemBatchActions: React.FC<IProps> = ({ row, ...rest }) => {
  const classes = useStyles();
  const notify = useNotifier();
  const history = useNavigate();
  const { refetchItemBatches: refetch } = useContext(ItemBatchContext);
  const { refetchItems } = useContext(ItemContext);

  const batchId: string = row.values["node._id"];
  /** sessionStorage key scoped to this batch so multiple in-flight exports
   *  (different batches) don't collide. */
  const exportSessionKey = `batchExport:${batchId}`;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [tokenizeModalOpen, setTokenizeModalOpen] = React.useState(false);
  const [progressModalOpen, setProgressModalOpen] = React.useState(false);
  const [fleetId, setFleetId] = useState("");
  const [itemsModalOpen, setItemsModalOpen] = useState(false);
  const [assignToFleetModalOpen, setAssignToFleetModalOpen] = useState(false);
  const [reAssignFleetModalOpen, setReAssignFleetModalOpen] = useState(false);
  const [assignToHolingFleetModalOpen, setAssignToHolingFleetModalOpen] = useState(false);
  const [provisionModalOpen, setProvisionModalOpen] = useState(false);
  const [totalItemsOpen, setTotalItemsOpen] = useState(false);
  const [itemFleet, setItemFleet] = useState('')
  const { startExportForBatch, starting: avatarExportStarting } =
    useBatchAvatarCsvExport(batchId);

  const handleProvisionModalOpen = useCallback(
    (value: boolean) => setProvisionModalOpen(value),
    []
  );
  const { loading, total, getItems } = useGetTotalItemsInBatch({
    batchNumber: row.values["node.batchNumber"],
  });
  const getNotes = useCallback(() => { }, []);

  const [angazaQID] = useState(getNotes());
  const [provisionLoading, setProvisionLoading] = useState(false);

  const [product_qid, setProductQID] = useState(
    // @ts-ignore
    angazaQID || ""
  );
  const [disableQIDInput] = useState(
    // @ts-ignore
    !!angazaQID || false
  );
  const [batchCodeModalOpen, setBatchCodeModalOpen] = useState(false);

  const handleBatchCodeModalOpen = useCallback(
    (value: boolean) => setBatchCodeModalOpen(value),
    []
  );
  const { create: batchCode, options: batchCodeOpts } = useBatchCode((data) => {
    refetchItems && refetchItems();
    notify({ status: "success", text: "Successfully provisioned" });
    setBatchCodeModalOpen(false);
    // Clear any lingering export session so the progress drawer doesn't
    // re-show an old download when opened for batch-code.
    sessionStorage.removeItem(exportSessionKey);
    setExportDownloadUrl(undefined);
    exportInitiatedRef.current = false;
    setProgressModalOpen(true);
  });




  const [codeDays, setCodeDays] = useState<number | string>(1);
  const handleCodeDaysChange = useCallback((value: string) => {
    setCodeDays(value);
  }, []);

  const handleBatchCodeSubmit = useCallback(() => {
    const days = parseInt(codeDays.toString(), 10);
    if (days < 0) {
      return notify({
        status: "error",
        text: "Code days must be more than zero.",
      });
    }
    batchCode({
      variables: {
        codeDays: days,
        batchId: row.values["node._id"],
      },
    });
  }, [codeDays, batchCode, row.values, notify]);

  const handleOpenTokenBatchCode = (value: OpenTokenBatchCodeInput) => {
    if (!value.token_type) {
      notify({ status: "error", text: "Please select a token type." });
      return;
    }
    openTokenBatch({
      variables: {
        batchCodeInput: {
          batchId: value.batchId,
          token_type: value.token_type,
          token_value: value.token_value
        }
      }
    })
  }

  const [deleteItem] = useMutation<DeleteItemBatch, DeleteItemBatchVariables>(
    deleteItemBatchMutation,
    {
      client: clientSimulator,
      onCompleted: (data) => {
        notify({
          status: "success",
          text: "Item batch deleted successfully",
        });
        refetch && refetch();
        setIsModalOpen(false);
      },
    }
  );

  const [openTokenBatch] = useMutation<OpenTokenBatchCode, OpenTokenBatchCodeVariables>(
    openTokenBatchCodeMutation, {
    client: clientSimulator,
    onCompleted: (data) => {

      notify({
        status: "success",
        text: "Token batch opened successfully",
      });
      refetch && refetch();
      setIsModalOpen(false); // Assuming this is available in the scope
    },
  });


  const [downloadingBatch, setDownloadingBatch] = useState(false);
  const [exportDownloadUrl, setExportDownloadUrl] = useState<string | undefined>();
  /** Prevents processing the same v2 query response twice on re-render. */
  const exportInitiatedRef = useRef(false);

  // On mount: restore an export session that survived a page refresh.
  useEffect(() => {
    try {
      const saved = sessionStorage.getItem(exportSessionKey);
      if (!saved) return;
      const { downloadUrl, startedAt } = JSON.parse(saved);
      const ONE_HOUR = 60 * 60 * 1000;
      if (Date.now() - startedAt < ONE_HOUR) {
        setExportDownloadUrl(downloadUrl);
        exportInitiatedRef.current = true;
      } else {
        sessionStorage.removeItem(exportSessionKey);
      }
    } catch {
      sessionStorage.removeItem(exportSessionKey);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [getFactoryItemsV2, { data: dataV2, loading: loadingFactoryItemsV2, error: errorV2 }] =
    useBatchFactoryExportV2Query({
      batchId: row.values["node._id"],
    });

  const [getOpenTokenFactoryItemsV2, { data: openTokenDataV2, loading: loadingOpenTokenFactoryItemsV2, error: errorOpenTokenV2 }] =
    useBatchFactoryOpenTokenExportV2Query({
      batchId: row.values["node._id"],
    });

  const [
    getItemsByBatchNumber,
    { data: itemData, loading: itemLoading, refetch: refetchItemss },
  ] = useLazyGetAllItemsQuery({
    first: 2,
    queryorder: QueryOrder.DESC,
    search: row.values["node.batchNumber"]
  });

  useEffect(() => {
    // @ts-ignore
    setItemFleet(itemData?.getAllItems?.page?.edges[0]?.node?.itemFleet?.fleetName)

  }, [itemData])

  // v2 standard export — persist URL + open progress drawer.
  useEffect(() => {
    if (!dataV2 || exportInitiatedRef.current) return;
    const url = dataV2?.batchFactoryExport_v2?.downloadUrl;
    const eventId = dataV2?.batchFactoryExport_v2?.eventId;
    if (url) {
      exportInitiatedRef.current = true;
      sessionStorage.setItem(
        exportSessionKey,
        JSON.stringify({ downloadUrl: url, eventId, startedAt: Date.now() })
      );
      setExportDownloadUrl(url);
      setProgressModalOpen(true);
      notify({ status: "success", text: "Export started — preparing download…" });
    } // eslint-disable-next-line
  }, [dataV2]);

  // v2 open-token export — same flow.
  useEffect(() => {
    if (!openTokenDataV2 || exportInitiatedRef.current) return;
    const url = openTokenDataV2?.batchFactoryExportOpenToken_v2?.downloadUrl;
    const eventId = openTokenDataV2?.batchFactoryExportOpenToken_v2?.eventId;
    if (url) {
      exportInitiatedRef.current = true;
      sessionStorage.setItem(
        exportSessionKey,
        JSON.stringify({ downloadUrl: url, eventId, startedAt: Date.now() })
      );
      setExportDownloadUrl(url);
      setProgressModalOpen(true);
      notify({ status: "success", text: "Export started — preparing download…" });
    } // eslint-disable-next-line
  }, [openTokenDataV2]);

  // Surface export errors to the user immediately.
  useEffect(() => {
    if (errorV2) handleGQLErrors(notify, errorV2);
  }, [errorV2]); // eslint-disable-line

  useEffect(() => {
    if (errorOpenTokenV2) handleGQLErrors(notify, errorOpenTokenV2);
  }, [errorOpenTokenV2]); // eslint-disable-line



  const [reassignBatchItems, { loading: reassingLoading }] = useMutation<reassignBatchItemsFromItemFleet, reassignBatchItemsFromItemFleetVariables>(
    reassignBatchItemsFromItemFleetMutation, {
    client: clientSimulator,
    onCompleted: () => {
      notify({
        status: "success",
        text: "Item batch Re-Assigned successfully",
      });
      setItemFleet("")
      setFleetId("")
      refetchItemss && refetchItemss();
      setReAssignFleetModalOpen(false);
    },
    onError: (err) => {
      handleGQLErrors(notify, err)
    }
  });
  const [assignBatchItems, { loading: assignLoading }] = useMutation<assignItemBatchToItemFleet, assignItemBatchToItemFleetVariables>(
    assignItemBatchToItemFleetMutation, {
    client: clientSimulator,
    onCompleted: () => {
      notify({
        status: "success",
        text: "Item batch Assigned successfully",
      });
      setFleetId("")
      refetchItemss && refetchItemss();
      setAssignToFleetModalOpen(false);
    },
    onError: (err) => {
      handleGQLErrors(notify, err)
    }
  });

  const handleAssignToFleet = async () => {
    if (!fleetId) {
      alert("Please select a fleet to proceed.");
      return;
    }
    assignBatchItems({ variables: { itemFleetId: fleetId, itemBatchId: row.values["node._id"] } })
  };
  const {
    getItems: getFleets,
    items: fleetItems,
    refetchItems: refetchFleets,
    loading: loadingFleet
  } = useContext(FleetContext);
  const searchFleet = async (search: string) => {
    if (!refetchFleets) {
      return Promise.resolve(
        fleetItems?.map((it) => ({
          name: it?.node?.fleetName,
          value: it?.node?._id,
        }))
      );
    }
    const refetchData = await refetchFleets({
      first: PAGE_LIST_LIMIT,
      search,
    });

    const items = refetchData?.data?.getAllItemFleets?.page?.edges?.map(
      (item) => {
        return {
          label: item?.node?.fleetName || "",
          value: item.node?._id || "",
        };
      }
    );
    return Promise.resolve(items as { value: string; label: string }[]);
  };

  const { create: provision, options: provisionOpts } = useProvisionBatch(
    (data) => {
      refetchItems && refetchItems();
      notify({ status: "success", text: "Successfully provisioned" });
    }
  );

  const searchProductQID = async (search: string) => {
    const res = productQIDOptions?.filter((it) => {
      return it?.label?.toLocaleLowerCase().includes(search);
    });
    return res;
  };

  const provisionProductBatch = () => {
    if (!product_qid) {
      return notify({ status: "error", text: "Product QID is required" });
    }

    setProvisionLoading(true);

    provision({
      variables: {
        qid: product_qid,
        batchId: row.values["node._id"],
      },
    });

    setProvisionLoading(false);
  };

  const handleReAssignBatchFleet = () => {
    if (!fleetId) {
      alert("Please select a fleet to proceed.");
      return;
    }
    reassignBatchItems({ variables: { itemFleetId: fleetId, itemBatchId: row.values["node._id"], isHolding: false } })
  }

  const handleAssignToHoldingFleet = () => {
    if (!fleetId) {
      alert("Please select a fleet to proceed.");
      return;
    }
    reassignBatchItems({ variables: { itemFleetId: fleetId, itemBatchId: row.values["node._id"], isHolding: true } })
  }


  const formFieldsData = useMemo(
    () => [
      {
        name: "",
        fields: [
          {
            md: 12,
            type: "select-async",
            name: "fleetId",
            label: "Fleet",
            options: fleetItems?.map((it) => ({
              _id: it?.node?._id || "",
              name: it?.node?.fleetName || "",
            })),
            onChange: (e: any) => {
              setFleetId(e);
            },
            value: fleetId || "",
            searchPromise: searchFleet as (
              arg: string
            ) => Promise<{ value: string; label: string }[]>,
          },
        ],
      },
    ], // eslint-disable-next-line
    [fleetItems, fleetId]
  );

  const tokenTypeOptions = [
    {
      _id: 'ADD_TIME',
      name: 'ADD_TIME'
    },
    {
      _id: 'SET_TIME',
      name: 'SET_TIME'
    },
    {
      _id: 'DISABLE_PAYG',
      name: 'DISABLE_PAYG'
    },
    {
      _id: 'COUNTER_SYNC',
      name: 'COUNTER_SYNC'
    },
  ]

  const openTokenValidationSchema = Yup.object().shape({
    token_type: Yup.string()
      .oneOf(['ADD_TIME', 'SET_TIME', 'DISABLE_PAYG', 'COUNTER_SYNC'], 'Please select a token type')
      .required('Please select a token type'),
  });

  return (
    <div className="actions-right" style={{ display: "flex" }}>
      <Tooltip
        title="Delete"
        placement="top"
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id="expander"
          aria-label="Delete"
          className={classes.tableActionButton}
          onClick={() => setIsModalOpen(true)}
        >
          <Delete
            className={classes.tableActionButtonIcon + " " + classes.delete}
          />
        </IconButton>
      </Tooltip>
      <Tooltip
        onClick={() => {
          history(itemBatchRoutes.getEditLink(row.values["node._id"]));
        }}
        title="Edit"
        placement="top"
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id="expander"
          aria-label="Edit"
          className={classes.tableActionButton}
        >
          <Edit
            className={classes.tableActionButtonIcon + " " + classes.edit}
          />
        </IconButton>
      </Tooltip>

      <HoverDropdown
        menus={[
          {
            name: "Batch Progress",
            action: () => {
              setProgressModalOpen(true);
            },
          },
          {
            name: "Initialize",
            action: () => {
              setTokenizeModalOpen(true);
            },
          },

          {
            name: "Assign to Fleet",
            action: () => {
              setAssignToFleetModalOpen(true);
              getFleets();
            },
          },
          {
            name: "Reassign Fleet",
            action: () => {
              setReAssignFleetModalOpen(true);
              getFleets();
              getItemsByBatchNumber();
            },
          },
          {
            name: "Assign to Holding",
            action: () => {
              setAssignToHolingFleetModalOpen(true);
              getFleets();
              getItemsByBatchNumber();
            },
          },

          {
            name: disableQIDInput ? "Angaza Re-provision" : "Angaza Provision",
            action: () => {
              setProvisionModalOpen(true);
            },
          },
          {
            name: "Batch Code",
            action: () => {
              setBatchCodeModalOpen(true);
            },
          },
          {
            name:
              loadingFactoryItemsV2 || loadingOpenTokenFactoryItemsV2
                ? "Initiating export…"
                : "Download factory products",
            action: () => {
              if (loadingFactoryItemsV2 || loadingOpenTokenFactoryItemsV2) return;
              // Clear any previous session and reset state for a fresh download.
              sessionStorage.removeItem(exportSessionKey);
              setExportDownloadUrl(undefined);
              exportInitiatedRef.current = false;
              if (row.values["node.code_gen_type"] === "OPENTOKEN") {
                getOpenTokenFactoryItemsV2();
              } else {
                getFactoryItemsV2();
              }
            },
          },
          {
            name: avatarExportStarting
              ? "Preparing avatar attr…"
              : "Download avatar attr",
            action: () => {
              if (avatarExportStarting) return;
              startExportForBatch(row.values["node._id"]);
            },
          },
          {
            name: "Total Batch Items",
            action: () => {
              setTotalItemsOpen(true);
              getItems();
            }
          },
        ]}
      />

      {/* batch code  */}
      <DrawerSidebar
        isModalOpen={batchCodeModalOpen}
        toggleModal={handleBatchCodeModalOpen}
        title={product_qid ?? `Batch Code generation`}
      >
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <h6>
              This will generate {codeDays} day code(s) for the products <br />
              in batchNumber {row.values["node.batchNumber"]}{" "}
            </h6>
          </GridItem>
          {row.values["node.code_gen_type"] === "OPENTOKEN" ? (
            <Formik
              onSubmit={(e: OpenTokenBatchCodeInput) => { handleOpenTokenBatchCode(e) }}
              initialValues={{
                batchId: row.values["node._id"],
                token_type: '' as OpenTokenCodeType,
                token_value: 1,
              }}
              validationSchema={openTokenValidationSchema}
            >
              {(formBag) => (
                <>
                  <GridItem md={12}>
                    <CustomSelect
                      selectOptions={tokenTypeOptions}
                      onChange={(e: any) => {
                        formBag.setFieldValue('token_type', e.target.value);
                        formBag.setFieldTouched('token_type', true, false);
                      }}
                      label={'Select Token Type'}
                      value={formBag.values.token_type || ''}
                      name={'token_type'}
                    />
                  </GridItem>
                  <GridItem md={12}>
                    <TextInput
                      label='Token Value'
                      name={'token_value'}
                      value={1}
                      multiline
                    />
                  </GridItem>
                  <GridItem sm={12}>
                    <Button
                      color="primary"
                      onClick={() => {
                        formBag.submitForm()
                      }}
                      style={{ marginLeft: 12 }}
                      disabled={itemLoading || reassingLoading}
                    >
                      {reassingLoading ? "Loading..." : "Save"}
                    </Button>
                  </GridItem>
                </>
              )}
            </Formik>
          ) : (
            <>
              <GridItem xs={12} sm={12} md={12}>
                <GridItem xs={12}>
                  <TextField
                    name="codeDays"
                    value={codeDays}
                    onChange={(e) => {
                      handleCodeDaysChange(e?.target?.value || "");
                    }}
                    type="number"
                  />
                </GridItem>

                <Grid>
                  <Button
                    color="primary"
                    onClick={() => {
                      handleBatchCodeSubmit();
                    }}
                    disabled={batchCodeOpts.loading}
                    style={{ marginLeft: 12 }}
                  >
                    Save
                  </Button>
                </Grid>
              </GridItem>
            </>
          )}
        </GridContainer>
      </DrawerSidebar>

      {/* initialization */}
      {tokenizeModalOpen ? (
        <BatchTokenizeModal
          isModalOpen={tokenizeModalOpen}
          setIsModalOpen={setTokenizeModalOpen}
          loading={false}
          handleOnClickOky={() => { }}
          progress={80}
          itemId={row.values["node._id"]}
          codeGenType={row.values["node.code_gen_type"]}
          onSuccess={() => {
            // Clear any lingering export session so the progress drawer doesn't
            // re-show an old download when opened after initialization.
            sessionStorage.removeItem(exportSessionKey);
            setExportDownloadUrl(undefined);
            exportInitiatedRef.current = false;
            setProgressModalOpen(true);
          }}
        />
      ) : null}
      {/* assign to fleet */}
      {assignToFleetModalOpen ? (
        <DrawerSidebar
          isModalOpen={assignToFleetModalOpen}
          toggleModal={setAssignToFleetModalOpen}
          title={`Assign ${row.values["node.batchNumber"]} to fleet`}
          styles={{ maxWidth: "30vw", minWidth: "400px" }}
        >
          <GridContainer>
            <Formik onSubmit={(e) => { }} initialValues={{}}>
              {(formBag) => (
                <>
                  <OVSForm formFieldsData={formFieldsData} />
                  <GridItem sm={12}>
                    <Button
                      color="primary"
                      onClick={() => {
                        handleAssignToFleet();
                      }}
                      style={{ marginLeft: 12 }}
                      disabled={loadingFleet || assignLoading}
                    >
                      {assignLoading ? 'Loading...' : 'Save'}
                    </Button>
                  </GridItem>
                </>
              )}
            </Formik>
          </GridContainer>
        </DrawerSidebar>
      ) : null}
      {reAssignFleetModalOpen ? (
        <DrawerSidebar
          isModalOpen={reAssignFleetModalOpen}
          toggleModal={setReAssignFleetModalOpen}
          title={`Re Assign ${row.values["node.batchNumber"]} Fleet`}
          styles={{ maxWidth: "30vw", minWidth: "400px" }}
        >
          <GridContainer>
            <Formik onSubmit={(e) => { }} initialValues={{}}>
              {(formBag) => (
                <>
                  <GridItem md={12}>
                    <TextInput
                      label='Item Fleet Name'
                      name={'item fleet'}
                      value={itemLoading ? "Loading..." : itemFleet ? itemFleet : "Loading..."}
                      multiline
                      disabled
                    />
                  </GridItem>
                  <OVSForm formFieldsData={formFieldsData} />
                  <GridItem sm={12}>
                    <Button
                      color="primary"
                      onClick={() => {
                        handleReAssignBatchFleet();
                      }}
                      style={{ marginLeft: 12 }}
                      disabled={itemLoading || reassingLoading}
                    >
                      {reassingLoading ? "Loading..." : "Save"}
                    </Button>
                  </GridItem>
                </>
              )}
            </Formik>
          </GridContainer>
        </DrawerSidebar>
      ) : null}
      {assignToHolingFleetModalOpen ? (
        <DrawerSidebar
          isModalOpen={assignToHolingFleetModalOpen}
          toggleModal={setAssignToHolingFleetModalOpen}
          title={`Assign ${row.values["node.batchNumber"]} To Holding Fleet`}
          styles={{ maxWidth: "30vw", minWidth: "400px" }}
        >
          <GridContainer>
            <Formik onSubmit={(e) => { }} initialValues={{}}>
              {(formBag) => (
                <>
                  <GridItem md={12}>
                    <TextInput
                      label='Item Fleet Name'
                      name={'item fleet'}
                      value={itemLoading ? "Loading..." : itemFleet ? itemFleet : "Loading..."}
                      multiline
                      disabled
                    />
                  </GridItem>
                  <OVSForm formFieldsData={formFieldsData} />
                  <GridItem sm={12}>
                    <Button
                      color="primary"
                      onClick={() => {
                        handleAssignToHoldingFleet();
                      }}
                      style={{ marginLeft: 12 }}
                      disabled={itemLoading || reassingLoading}
                    >
                      {reassingLoading ? "Loading..." : "Reassign Fleet"}
                    </Button>
                  </GridItem>
                </>
              )}
            </Formik>
          </GridContainer>
        </DrawerSidebar>
      ) : null}
      {/* Progress Modal */}
      {progressModalOpen ? (
        <DrawerSidebar
          isModalOpen={progressModalOpen}
          toggleModal={setProgressModalOpen}
          title={`Batch Progress State`}
          styles={{ maxWidth: "60vw", minWidth: "60vw" }}
        >
          <BatchProgressPage
            data={row.values["node.actionProgress"]}
            batchId={batchId}
            exportDownloadUrl={exportDownloadUrl}
            onDownloadTriggered={() => sessionStorage.removeItem(exportSessionKey)}
            onExportFailed={() => {
              sessionStorage.removeItem(exportSessionKey);
              setExportDownloadUrl(undefined);
              exportInitiatedRef.current = false;
            }}
            onCancelExport={() => {
              sessionStorage.removeItem(exportSessionKey);
              setExportDownloadUrl(undefined);
              exportInitiatedRef.current = false;
              notify({ status: "info", text: "Export cancelled. You can start a new download." });
            }}
          />
        </DrawerSidebar>
      ) : null}
      {/* delete modal */}
      {isModalOpen ? (
        <ActionModal
          isModalOpen={isModalOpen}
          toggleModal={setIsModalOpen}
          handleOnClickOkey={() =>
            deleteItem({ variables: { itemBatchId: row.values["node._id"] } })
          }
          handleOnClickCancel={() => setIsModalOpen(false)}
          okText="Delete"
        >
          <div>Are you sure you want to delete this item Batch?</div>
        </ActionModal>
      ) : null}

      {downloadingBatch ? (
        <ActionModal
          isModalOpen={downloadingBatch}
          toggleModal={setDownloadingBatch}
          handleOnClickCancel={() => setIsModalOpen(false)}
          okText="&nbsp;"
        >
          <div>Loading...</div>
        </ActionModal>
      ) : null}

      {/* assign item to batch */}
      {itemsModalOpen ? (
        <DrawerSidebar
          isModalOpen={itemsModalOpen}
          toggleModal={setItemsModalOpen}
          title={`Assigned Items ${row.values["node.batchNumber"]}`}
          styles={{ minWidth: "800px", maxWidth: "940px" }}
        >
          {itemsModalOpen ? (
            <AllItemsPage batchID={row.values["node._id"]} />
          ) : null}
        </DrawerSidebar>
      ) : null}
      {/* Show total items in Batch */}
      {totalItemsOpen ? (
        <ActionModal
          isModalOpen={totalItemsOpen}
          toggleModal={setTotalItemsOpen}
          handleOnClickOkey={() => {
            setTotalItemsOpen(false)
          }}
          handleOnClickCancel={() => {
            setTotalItemsOpen(false)
          }}
          okText="Ok"
        >
          <div>
            <b>Total: </b>
            <span>
              {loading ? "loading..." : `${numberWithCommas(total || 0)}`}
            </span>
          </div>
        </ActionModal>
      ) : null}
      {/* provision */}
      <DrawerSidebar
        isModalOpen={provisionModalOpen}
        toggleModal={handleProvisionModalOpen}
        title={product_qid ?? `Provision to ${product_qid}`}
      >
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <h6>
              This will provision the products <br /> in batchNumber{" "}
              {row.values["pbatchNumber"]}{" "}
            </h6>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <OVSForm
              formFieldsData={[
                {
                  name: "",
                  fields: [
                    {
                      md: 12,
                      disabled: disableQIDInput,
                      type: "select-async",
                      name: "product_qid",
                      label: "Product QID",
                      options: productQIDOptions.map((it) => ({
                        _id: it.value,
                        name: it.label,
                      })),
                      onChange: (e: any) => {
                        setProductQID(e);
                      },
                      value: product_qid || "",
                      searchPromise: searchProductQID,
                    },
                  ],
                },
              ]}
            />
            <Grid>
              <Button
                color="primary"
                onClick={() => {
                  provisionProductBatch();
                }}
                disabled={provisionLoading || provisionOpts.loading}
                style={{ marginLeft: 12 }}
              >
                Save
              </Button>
            </Grid>
          </GridItem>
        </GridContainer>
      </DrawerSidebar>

       {assignToFleetModalOpen ? (
        <DrawerSidebar
          isModalOpen={assignToFleetModalOpen}
          toggleModal={setAssignToFleetModalOpen}
          title={`Assign ${row.values["node.batchNumber"]} to fleet`}
          styles={{ maxWidth: "30vw", minWidth: "400px" }}
        >
          <GridContainer>
            <Formik onSubmit={(e) => { }} initialValues={{}}>
              {(formBag) => (
                <>
                  <OVSForm formFieldsData={formFieldsData} />
                  <GridItem sm={12}>
                    <Button
                      color="primary"
                      onClick={() => {
                        handleAssignToFleet();
                      }}
                      style={{ marginLeft: 12 }}
                      disabled={loadingFleet || assignLoading}
                    >
                      {assignLoading ? 'Loading...' : 'Save'}
                    </Button>
                  </GridItem>
                </>
              )}
            </Formik>
          </GridContainer>
        </DrawerSidebar>
      ) : null}
    </div>
  );
};

export default ItemBatchActions;
